var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.project.type === 'repo')?_c('LargeRepoCard',{key:_vm.project.data.id,attrs:{"repo":_vm.project.data,"showTags":_vm.showTags,"showLogo":_vm.showLogo}}):(_vm.project.type === 'blog')?_c('LargeBlogCard',{key:_vm.project.data.id,attrs:{"blog":_vm.project.data,"showTags":_vm.showTags,"showLogo":_vm.showLogo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }